var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-wrapper row m-0"},[_c('SearchBar'),_c('Logo'),_c('div',{staticClass:"left-header col horizontal-wrapper pl-0"}),_c('div',{staticClass:"nav-right col-8 pull-right right-header p-0"},[_c('ul',{staticClass:"nav-menus"},[_c('li',[_c('Mode')],1),_c('Profile')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }